// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1__t9","cls2":"PremiumBadge-cls2_aND PremiumBadge-cls1__t9"};